import {
  getTranslatedCubeQueryIntoSQL,
  GetTranslatedCubeQueryIntoSQLParams,
} from '@/storybook/components/DownloadDataButton/parts/translateCubeQueryToSQL';
import { DownloadButtonProps } from '@/types/download/DownloadButtonProps';
import { Logger } from '@/utils/Logger';
import { CubejsApi, Filter } from '@cubejs-client/core';

type GetTranslatedQueryProps = Omit<DownloadButtonProps, 'cubejsApi'> & { cubejsApi?: CubejsApi };

export const getTranslatedQuery = async ({
  queryFilters,
  additionalFilters,
  baseQuery,
  cubejsApi,
  translationsMap,
  dateRange,
  additionalQueryParser,
}: GetTranslatedQueryProps) => {
  if (!cubejsApi) {
    throw new Error('cubejsApi instance is required');
  }
  const query: GetTranslatedCubeQueryIntoSQLParams = {
    baseQuery,
    globalFilterApplied: [...(queryFilters ? [queryFilters] : []), ...(additionalFilters ?? [])] as Filter[],
    cubejsApiCallback: cubejsApi,
    translationsMap: translationsMap ?? {},
    dateRange,
    additionalQueryParser,
  };

  try {
    return await getTranslatedCubeQueryIntoSQL(query);
  } catch (error) {
    Logger.error('DownloadData', 'Error translating query', error);
    throw new Error('Failed to translate query');
  }
};
